import React, { useMemo } from 'react';
import RadioGroup from '@nib-components/radio-group';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { Stack } from '@nib/layout';
import { generateIncomeRanges } from './generateIncomeRanges';
import { formatDecimal } from '../../util/format-decimal';
import Copy from '@nib-components/copy';
import { defaultFieldPropTypes } from '../../types';
import { FUNNELS } from '../../util/constants';
import { RebateInfoMessage } from './RebateInfoMessage';
import { StandardInfoBox } from '../info-box';
const singleLabel = 'What is your annual income?';
const coupleFamilyLabel = 'What is your combined annual income?';
const LABELS = {
  ARHI: {
    Single: singleLabel,
    Couple: coupleFamilyLabel,
    Family: coupleFamilyLabel,
    SingleParentFamily: singleLabel
  }
};
export const AnnualIncome = props => {
  const {
    incomeTierLimits = [90000, 105000, 140000],
    inline = false,
    showRebateMessage = true,
    id = 0,
    funnel = FUNNELS.ARHI,
    required
  } = props;
  // Using useMemo for optimisation. The function will only execute if the values have changed.
  const OPTIONS = useMemo(() => {
    const incomeRanges = generateIncomeRanges(incomeTierLimits);
    return {
      ARHI: {
        Single: incomeRanges,
        Couple: incomeRanges,
        Family: incomeRanges,
        SingleParentFamily: incomeRanges
      }
    };
  }, [incomeTierLimits]);
  return React.createElement(Stack, {
    space: 2
  }, !props.hideRebateMessage && React.createElement(RebateInfoMessage, {
    scale: props.scale,
    display: "inline-flex",
    marginBottom: "5"
  }), React.createElement(BaseFormField, {
    required: required,
    ...props,
    label: props.label || LABELS[funnel] && LABELS[funnel][props.scale] || LABELS.ARHI[props.scale],
    inline: inline
  }, React.createElement(RadioGroup, {
    options: props.options || OPTIONS[funnel] && OPTIONS[funnel][props.scale] || OPTIONS.ARHI[props.scale]
  })), props.values[id] && props.values[id] === 'NoRebate' && React.createElement(StandardInfoBox, {
    withTip: true
  }, React.createElement(Copy, null, props.noRebateMessage)), props.values[id] && props.values[id] !== 'NoRebate' && showRebateMessage && React.createElement(StandardInfoBox, {
    role: "status",
    withTip: true
  }, React.createElement(Copy, null, props.rebateMessage)), props.newPrice && React.createElement(StandardInfoBox, {
    role: "status",
    withTip: false
  }, React.createElement(Copy, null, "Your price has been updated to reflect your changed Australian Government Rebate details. ", React.createElement("strong", null, "New price $", formatDecimal(props.newPrice, {
    places: 2,
    separator: ','
  }), "*."))));
};
AnnualIncome.defaultProps = {
  ...defaultFieldPropTypes,
  noRebateMessage: 'No worries. You can always look to apply the rebate at a later date.',
  incomeTierLimits: [90000, 105000, 140000],
  inline: false,
  showRebateMessage: true
};
const AnnualIncomeWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(AnnualIncome, {
  ...props
}));
export default AnnualIncomeWithFunnel;